import { ReactNode, SyntheticEvent, useState } from 'react';
import { Box, TabProps, TabsProps } from '@mui/material';

import { StyledTab, StyledTabs } from './styles';
import { TabPanel } from './TabPanel';

export type TTab = Omit<TabProps, 'content'> & {
  content?: ReactNode;
};

type TTabs = Omit<TabsProps, 'children'> & {
  tabs: TTab[];
  value: number | string;
  defaultValue?: number | string;
  onChange?: (event: SyntheticEvent, newValue: number | string) => void;
};

export const Tabs = ({
  tabs,
  value: externalValue,
  defaultValue,
  onChange,
  ...props
}: TTabs) => {
  const [internalValue, setInternalValue] = useState(
    defaultValue ?? tabs[0]?.value
  );
  const isControlled = externalValue !== undefined;
  const value = isControlled ? externalValue : internalValue;

  const handleChange = (event: SyntheticEvent, newValue: number | string) => {
    if (!isControlled) setInternalValue(newValue);
    onChange?.(event, newValue);
  };

  return (
    <Box>
      <StyledTabs value={value} onChange={handleChange} {...props}>
        {tabs.map(({ content, ...tabProps }) => (
          <StyledTab
            key={tabProps.value.toString()}
            {...tabProps}
            value={tabProps.value}
            label={tabProps.label}
          />
        ))}
      </StyledTabs>

      {tabs.map(
        (tab) =>
          tab.content && (
            <TabPanel
              key={`panel-${tab.value}`}
              value={value}
              tabValue={tab.value}
            >
              {tab.content}
            </TabPanel>
          )
      )}
    </Box>
  );
};
